export default {
  pageName: 'Ai Insight Report',
  pageId: '25052',
  pagePath: '/opinion/AIAnalysisHub/AIInsightsReport',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    // 切换报告
    ChangeReport: {
      buttonId: '25052001',
    },
    // 选中报告时间
    ChangeDate: {
      buttonId: '25052002',
    },
    // 切换报告语种
    ChangeLanguage: {
      buttonId: '25052003',
    },
    // 下载评论（仅高级版报告有）
    DownloadComments: {
      buttonId: '25052004',
    },
    // 点击修改例行设置
    EditRepeatSettings: {
      buttonId: '25052005',
    },
    // 点击查看例行设置详情
    RepeatDetailSetting: {
      buttonId: '25052006',
    },
  },
};
